import React, { lazy } from "react";
import HomeProvider from "../pages/home/HomeProvider";
import PrivateRoutesComponent from "./PrivateRoutesComponent";
import PrivateRoutes from "./PrivateRoutes";
import PathConstants from "./pathConstants";
import EndSession from "../pages/endSession/EndSession";
import RecordedLiveLessonForMobilePage from "../pages/recordedLiveLessonForMobile/RecordedLiveLessonForMobilePage";

// import Login from "../pages/login/Login";
// import ForgetPassword from "../pages/resetPassword/ForgetPassword";
// import VerifyCode from "../pages/resetPassword/VerifyCode";
// import ResetPassword from "../pages/resetPassword/ResetPassword";
// import Register from "../pages/register/Register";
// import VerifyAccount from "../pages/verifyAccount/VerifyAccount";

// import ContactUs from "../pages/contactUs/ContactUs";
// import Activities from "../pages/activities/Activities";
// import Gallery from "../pages/gallery/Gallery";
// import TrainerProfile from "../pages/trainerProfile/TrainerProfile";

// import Courses from "../pages/courses/Courses";
// import CourseDetails from "../pages/courseDetails/CourseDetails";

const Login = lazy(() => import("../pages/login/Login"));
const ForgetPassword = lazy(() =>
  import("../pages/resetPassword/ForgetPassword")
);
const VerifyCode = lazy(() => import("../pages/resetPassword/VerifyCode"));
const ResetPassword = lazy(() =>
  import("../pages/resetPassword/ResetPassword")
);
const Register = lazy(() => import("../pages/register/Register"));
const VerifyAccount = lazy(() =>
  import("../pages/verifyAccount/VerifyAccount")
);

const ContactUs = lazy(() => import("../pages/contactUs/ContactUs"));
const Activities = lazy(() => import("../pages/activities/Activities"));
const Gallery = lazy(() => import("../pages/gallery/Gallery"));
const TrainerProfile = lazy(() =>
  import("../pages/trainerProfile/TrainerProfile")
);

const Courses = lazy(() => import("../pages/courses/Courses"));
const CourseDetails = lazy(() =>
  import("../pages/courseDetails/CourseDetails")
);

const PrivacyPolicy = lazy(() =>
  import("../pages/privacyPolicy/PrivacyPolicy")
);
const TermsAndConditions = lazy(() =>
  import("../pages/termsAndConditions/TermsAndConditions")
);
const ScientificCertified = lazy(() =>
  import("../pages/scientificCertified/ScientificCertified")
);

const routes = [
  { path: PathConstants.Home, element: <HomeProvider /> },
  { element: <PrivateRoutesComponent />, children: PrivateRoutes },
  // other mappings ...
  //   Auth
  { path: PathConstants.Login, element: <Login /> },
  { path: PathConstants.Register, element: <Register /> },
  { path: PathConstants.ForgetPassword, element: <ForgetPassword /> },
  { path: PathConstants.VerifyAccount, element: <VerifyAccount /> },
  { path: PathConstants.VerifyCode, element: <VerifyCode /> },
  { path: PathConstants.ResetPassword, element: <ResetPassword /> },

  // Others
  { path: PathConstants.ContactUs, element: <ContactUs /> },
  { path: PathConstants.Activities, element: <Activities /> },
  { path: PathConstants.Gallery, element: <Gallery /> },
  { path: PathConstants.TrainerProfile, element: <TrainerProfile /> },
  { path: PathConstants.PrivacyPolicy, element: <PrivacyPolicy /> },
  { path: PathConstants.TermsAndConditions, element: <TermsAndConditions /> },
  { path: PathConstants.ScientificCertified, element: <ScientificCertified /> },

  // courses
  { path: PathConstants.Courses, element: <Courses /> },
  { path: PathConstants.CoursesWithSpecificCategory, element: <Courses /> },
  { path: PathConstants.CourseDetails, element: <CourseDetails /> },
  { path: PathConstants.RecordedCourseDetails, element: <CourseDetails /> },
  { path: PathConstants.EndSession, element: <EndSession /> },

  {
    path: PathConstants.RecordedLiveLessonForMobile,
    element: <RecordedLiveLessonForMobilePage />,
  },
];

export default routes;
